"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWrapper = exports.Tab = exports.TabWrapper = exports.WidgetWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.WidgetWrapper = styled_components_1.default.div `
  background: #ffffff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 414px;
  min-height: 464px;
  @media only screen and (min-width: 414px) {
    border-radius: 16px;
  }
`;
const bgGradient = (tab) => tab === "buy"
    ? `linear-gradient(to right, #0085ff 0 50%, #f1f7fd 50% 100%)`
    : `linear-gradient(to right, #f1f7fd 0 50%, #0085ff 50% 100%)`;
exports.TabWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  transition: all 1s;

  &::after {
    content: "";
    flex-basis: 100%;
    height: 5px;
    width: 100%;
    background: ${({ tab }) => bgGradient(tab)};
  }
`;
exports.Tab = styled_components_1.default.div `
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  flex-basis: 50%;
  padding: 16px 0;
  cursor: pointer;

  color: ${({ selected }) => (selected ? "#0085FF" : "#8A94A6")};
`;
exports.ContentWrapper = styled_components_1.default.div `
  padding: 24px;
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
`;
//# sourceMappingURL=styled.js.map